module.exports = __webpack_public_path__ + "img/P4-1-4.b7a8c096.svg";